import { makeAutoObservable } from "mobx"

export default class List {
  name: string
  listType: string
  lockedToTripLeaders: boolean
  tripLeaderPermission: "full" | "assign_only" | "read_only"
  status: string
  reviewNote: string

  constructor(props: any) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.name = props.name
    this.listType = props.listType
    this.lockedToTripLeaders = props.lockedToTripLeaders
    this.tripLeaderPermission = props.tripLeaderPermission
    this.status = props.status
    this.reviewNote = props.reviewNote
  }
}

export function typeNoun(list) {
  switch (list.listType) {
    case "bus_list":
      return "bus"
    case "room_list":
      return "room"
    case "flight_list":
      return "flight"
    case "chaperone_list":
      return "chaperone list"
    default:
      return "group"
  }
}
